import { usePropertyExpandingConditionedSqFt } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';

interface ExpandingConditionedSqFtProps {
    propertyGuid: string;
    isReview?: boolean;
}

export const ExpandingConditionedSqFt: React.FC<ExpandingConditionedSqFtProps> = ({ propertyGuid, isReview = false }) => {
    const label = 'Expanding conditioned sq ft.?';
    const [expandingConditionedSqFt, set_expandingConditionedSqFt] = usePropertyExpandingConditionedSqFt(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_expandingConditionedSqFt(true);
                return;
            case 'no':
                set_expandingConditionedSqFt(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={expandingConditionedSqFt ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonExpandingConditionedSqFt'
                    value={expandingConditionedSqFt}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
